module.exports = __webpack_public_path__ + "static/media/screen5.e4e1368c.png";